import React from "react";

export interface StoreyMeasurementContextProps {
    isMeasurementToolOpen: boolean;
    measuredLines: number[];
    openMeasurementTool: () => void;
    closeMeasurementTool: () => void;
    toggleMeasurementTool: (open?: boolean) => void;
    addMeasuredLine: (val: number) => void;
    clearMeasuredLines: () => void;
}

export const StoreyMeasurementContext = React.createContext<StoreyMeasurementContextProps | undefined>(undefined);
